import { render, staticRenderFns } from "./EditTipoLocal.vue?vue&type=template&id=1e548302"
import script from "./EditTipoLocal.vue?vue&type=script&lang=js"
export * from "./EditTipoLocal.vue?vue&type=script&lang=js"
import style0 from "./EditTipoLocal.vue?vue&type=style&index=0&id=1e548302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports